import React, { useEffect, useContext } from 'react';
import GlobalContext from '../../contexts/global.js';
import StateContext from '../../contexts/state.js';
import UserContext, { isPartner, isDirector } from '../../contexts/user.js';
import Listing from '../../components/Listing.js';
import { changeBrowserTitle } from '../../hooks/headAmender.js';
import WelcomeBanner from '../../components/WelcomeBanner.js';
import locationBadgeIcon from '../../helpers/locationBadgeIcon.js';

const Home = ({ prefix }) => {
    const { globalContext } = useContext(GlobalContext);
    const { state, updateState } = useContext(StateContext);
    const { userContext } = useContext(UserContext);

    const localStoriesPresent = state.userLocation?.length > 0;

    /* Set browser title */
    changeBrowserTitle(globalContext?.siteConfig?.siteName || "Homepage");

    useEffect(() => {
        updateState({
            banner: <WelcomeBanner />
        });

        return () => {
            updateState({ banner: null });
        }
    }, []);

    const badgeKeys = [
        { key: "los", icon: "people" },
        { key: "location", icon: locationBadgeIcon }
    ];

    return (
        <>
            {
                false && isPartner(userContext) && (
                    <section>
                        <Listing
                            heading="Partners"
                            viewAllLink="/partners"
                            filterGroups={[
                                { key: "gradeName", value: "partners" }
                            ]}
                            initialCount={2}
                            paginateBy={5}
                            badgeKeys={badgeKeys}
                            showEmptyListing={false}
                        />
                    </section>
                )
            }

            {
                false && isDirector(userContext) && (
                    <section>
                        <Listing
                            heading="Directors"
                            viewAllLink="/directors"
                            filterGroups={[
                                { key: "gradeName", value: "directors" }
                            ]}
                            initialCount={2}
                            paginateBy={5}
                            badgeKeys={badgeKeys}
                            showEmptyListing={false}
                        />
                    </section>
                )
            }

            {
                state.currentLos?.length > 0 && (
                    <section>
                        <Listing
                            heading="Your Line of Service"
                            filterGroups={[
                                {
                                    key: "location",
                                    value: [ "" ]
                                }
                            ]}
                            initialCount={3}
                            paginateBy={3}
                            badgeKeys={badgeKeys}
                            showEmptyListing={false}
                        />
                    </section>
                )
            }

            {
                localStoriesPresent && (
                    <section>
                        <Listing
                            heading="Your location"
                            viewAllLink="/local-stories"
                            filterGroups={[
                                {
                                    key: "location",
                                    value: state.userLocation.map(({ key }) => key)
                                }
                            ]}
                            initialCount={3}
                            paginateBy={3}
                            badgeKeys={badgeKeys}
                            showEmptyListing={false}
                        />
                    </section>
                )
            }
        </>
    );
};

export default Home;
